import React, { Component, useEffect, useState } from "react";
import { postData, getData, patchData, deleteData } from '../../util/Fetch';
import { Button } from "reactstrap";
import swal from "sweetalert";
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import Chip from '@mui/material/Chip';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(selected, wholeData, theme) {
  return {
    fontWeight:
        wholeData.indexOf(selected) === -1
            ? theme.typography.fontWeightRegular
            : theme.typography.fontWeightMedium,
  };
}

const SalonConfig = () => {
    const theme = useTheme();
    const [config, setConfig] = useState({
        id: 0,
        reserveDuration: 0,
        officialDayoff: [],
        reserveLimitDay: 0,
        endHour:0,
        startHour:0
    })

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
    PaperProps: {
        style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
        },
    },
    };

    const customStyles = {
        option: (provided, state) => ({
          color: state.isSelected ? 'red' : 'blue',
        }),
      }
      

    useEffect(() => {
        getConfig();
    }, []);

    const getConfig = () => {
        getData('config').then(res =>{
            res.officialDayoff = res.officialDayoff.split(',').map(x => { return parseInt(x) });
            setConfig(res);
        });
    }

    const handleMultiSelectChange = (event) => {
        const {
          target: { value },
        } = event;
        setConfig({
            ...config, officialDayoff: typeof value === 'string' ? value.split(',').sort() : value.sort()}
        );
      };

    const handleChange = e => {
        if(e.target.type === "number"){
            setConfig({ ...config, [e.currentTarget.id]: parseInt(e.currentTarget.value) });
        }
        else{
            setConfig({ ...config, [e.currentTarget.id]: e.currentTarget.value });
        }
    };

    const handleSelectChange = e => {
        setConfig({ ...config, reserveDuration: parseInt(e.target.value) });
    }


    const handleSubmit = () => {
        postData('config', { ...config, officialDayoff: config.officialDayoff.join()}).then(res => {
            if(res === true){
                getConfig();
                swal("更新成功", "設定已順利更新", "success");
            }
        })
    }

    return (
        <div>
            <Stack spacing={2} sx={{ width: '100%', marginTop: '5%' }}>
                        <FormControl sx={{ m: 1, minWidth: 120 }}>
                            <InputLabel id="reserveDuration">預約時段最小間隔(分鐘)</InputLabel>
                            <Select
                                id="reserveDuration"
                                value={config.reserveDuration}
                                label="預約時段最小間隔(分鐘)"
                                onChange={handleSelectChange}
                                >
                                <MenuItem key={30} value={30}>{"30分鐘"}</MenuItem>
                                <MenuItem key={60} value={60}>{"60分鐘"}</MenuItem>
                            </Select>   
                        </FormControl>             
            </Stack>
            <Stack spacing={2} sx={{ width: '100%', marginTop: '2%' }}>
                <FormControl sx={{ m: 1, minWidth: 120 }}>
                    <InputLabel id="officialDayoff">公休日</InputLabel>
                    <Select
                    style={customStyles}
                    labelId="demo-multiple-chip-label"
                    id="officialDayoff"
                    multiple
                    value={config.officialDayoff}
                    onChange={handleMultiSelectChange}
                    input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                    renderValue={(selected) => (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {selected.map((value) => (
                            <Chip key={value} label={value} />
                        ))}
                        </Box>
                    )}
                    MenuProps={MenuProps}
                    >
                    <MenuItem key={1} value={1} style={getStyles(1, config.officialDayoff, theme)}>{"星期一"}</MenuItem>
                    <MenuItem key={2} value={2} style={getStyles(2, config.officialDayoff, theme)}>{"星期二"}</MenuItem>
                    <MenuItem key={3} value={3} style={getStyles(3, config.officialDayoff, theme)}>{"星期三"}</MenuItem>
                    <MenuItem key={4} value={4} style={getStyles(4, config.officialDayoff, theme)}>{"星期四"}</MenuItem>
                    <MenuItem key={5} value={5} style={getStyles(5, config.officialDayoff, theme)}>{"星期五"}</MenuItem>
                    <MenuItem key={6} value={6} style={getStyles(6, config.officialDayoff, theme)}>{"星期六"}</MenuItem>
                    <MenuItem key={0} value={0} style={getStyles(0, config.officialDayoff, theme)}>{"星期日"}</MenuItem>

                    </Select>
                </FormControl>
            </Stack>
            <Stack spacing={2} sx={{ width: '100%', marginTop: '2%' }}>
                <FormControl sx={{ m: 1, minWidth: 120 }}>
                    <TextField id="reserveLimitDay" value={config.reserveLimitDay} label="最遠可預約日期(日)" onChange={handleChange} required variant="outlined" type="number" />
                </FormControl>
            </Stack>
            <Stack spacing={2} sx={{ width: '100%', marginTop: '2%' }}>
                <FormControl sx={{ m: 1, minWidth: 120 }}>
                    <TextField id="startHour" value={config.startHour} label="上班時間(點)" onChange={handleChange} required variant="outlined" type="number" />
                </FormControl>
            </Stack>
            <Stack spacing={2} sx={{ width: '100%', marginTop: '2%' }}>
                <FormControl sx={{ m: 1, minWidth: 120 }}>
                    <TextField id="endHour" value={config.endHour} label="下班時間(點)" onChange={handleChange} required variant="outlined" type="number" />
                </FormControl>
            </Stack>
            <Stack spacing={2} sx={{ width: '100%', marginTop: '2%' }}>
                <FormControl sx={{ m: 1, minWidth: 120 }}>
                    <Button variant="contained" onClick={handleSubmit}>更新</Button>
                </FormControl>
            </Stack>
        </div>
        
    );
}

export default SalonConfig
